export const CARD_TYPES = {
  ARTICLE: 'article',
  MEMBER_STORY: 'member_story',
};

export const DEFAULT_CATEGORIES = {
  DEV_SUCCESS_CATEGORY: 'developer-success',
  DEV_DOWNLOADS_CATEGORY: 'dev-downloads',
};

export const useJournalStore = defineStore('journal', {
  state: () => ({
    mainArticle: null,
    articles: [],
    popularArticles: [],
    leadgenPages: [],
    categories: [],
    category: null,
    currentPage: 1,
    totalPages: 1,
    perPage: 12,
    currentPageLeadgen: 1,
    totalPagesLeadgen: 1,
    perPageLeadgen: 6,
  }),
  actions: {
    setMainArticle(article) {
      this.mainArticle = article;
    },
    setPopularArticles(articles) {
      this.popularArticles = articles;
    },
    setArticles(articles) {
      this.articles = [...this.articles, ...articles.data];
      this.currentPage = Number(articles.pagination.current_page);
      this.totalPages = Number(articles.pagination.total_pages);
    },
    setLeadgenPages(pages) {
      this.leadgenPages = [...this.leadgenPages, ...pages.data];
      this.currentPageLeadgen = Number(pages.meta.pagination.current_page);
      this.totalPagesLeadgen = Number(pages.meta.pagination.last_page);
    },
    resetArticles() {
      this.articles = [];
      this.currentPage = 1;
      this.totalPages = 1;
    },
    resetLeadgenPages() {
      this.leadgenPages = [];
      this.currentPageLeadgen = 1;
      this.totalPagesLeadgen = 1;
    },
    setCategory(category) {
      this.category = category;
    },
    setCategories(categories) {
      this.categories = categories;
    },
    incrementCurrentPage() {
      if (this.currentPage >= this.totalPages) {
        return;
      }
      this.currentPage += 1;
    },
    incrementCurrentPageLeadgen() {
      if (this.currentPageLeadgen >= this.totalPagesLeadgen) {
        return;
      }
      this.currentPageLeadgen += 1;
    },
  },
  getters: {
    categorySlugs: (state) => [
      ...state.categories.map((category) => category.slug),
      ...Object.values(DEFAULT_CATEGORIES),
    ],
    filterParams(state) {
      const category = this.categorySlugs.includes(state.category)
        ? state.category
        : null;

      return {
        page: state.currentPage,
        perPage: state.perPage,
        ...(category && { category }),
      };
    },
    leadgenFilterParams: (state) => ({
      page: state.currentPageLeadgen,
      perPage: state.perPageLeadgen,
      detailed: 1,
    }),
    chunkedArticles(state) {
      const chunkSize = 3;
      const chunks = [];

      for (let index = 0; index < state.articles.length; index += chunkSize) {
        chunks.push(state.articles.slice(index, index + chunkSize));
      }

      return chunks;
    },
    hasMoreArticles: (state) => state.currentPage < state.totalPages,
    isLeadgenPageCategory: (state) =>
      state.category === DEFAULT_CATEGORIES.DEV_DOWNLOADS_CATEGORY,
    hasMoreLeadgenPages: (state) =>
      state.currentPageLeadgen < state.totalPagesLeadgen,
  },
});
